import {
    Button,
    CircularProgress,
    IconButton,
    Tooltip
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { ActionButtonProps } from './types';

export default function ActionButton(props: ActionButtonProps) {
    const {
        className,
        id,
        Icon,
        iconColor,
        text,
        type,
        handleClick,
        disabled,
        actionInProgress = false
    } = props;

    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    if (type === 'icon' && Icon) {
        // Tooltip creates an error when putting around a disabled input, so adding the below if condition
        if (disabled || actionInProgress) {
            return (
                <IconButton
                    className={`${classes.root} ${className} ${classes.iconContainer} ${classes.iconButton}`}
                    disabled={disabled || actionInProgress}
                    id={id}
                    onClick={handleClick}
                >
                    {actionInProgress ?
                        <CircularProgress
                            className={classes.actionInProgressIcon}
                            size={24}
                        />
                        : (
                            <Icon
                                className={classes.icon}
                                iconColor={iconColor ||
                                    theme?.app?.clientTheme.colors.primaryColor ||
                                    '#375073'}
                            />
                        )}
                </IconButton>
            );
        }

        return (
            <Tooltip
                classes={{ popper: classes.tooltip }}
                disableInteractive
                title={text || ''}
            >
                <IconButton
                    className={`${classes.root} ${className} ${classes.iconContainer} ${classes.iconButton}`}
                    disabled={disabled}
                    id={id}
                    onClick={handleClick}
                >
                    <Icon
                        className={classes.icon}
                        iconColor={iconColor ||
                            theme?.app?.clientTheme.colors.primaryColor ||
                            '#375073'}
                    />
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Button
            className={`${classes.root} ${className} ${classes.textContainer}
                ${type === 'primary' ? classes.primary : classes.muted}`}
            disabled={disabled || actionInProgress}
            id={id}
            onClick={handleClick}
        >
            {actionInProgress ?
                <CircularProgress
                    className={classes.actionInProgressIcon}
                    size={24}
                />
                : text}
        </Button>
    );
}